import React, { useEffect } from 'react'

import { ReactComponent as CloseSVG } from '../../assets/svg/notifyClose.svg'

import { NotificationContainer, Icon } from './NotificationStyled'

import Container from 'pages/container/Container'
import SFXS from '../../assets/audios/audios'

interface NOTIFICATION_PROPS {
  text: string
  handleNotification: any
  fadeOut: boolean
  colors: {
    secondary: string
    tertiary: string
  }
  audio?: any
}

export default function Notification({
  text,
  handleNotification,
  fadeOut,
  colors,
  audio,
}: NOTIFICATION_PROPS) {
  const { notificationSFX } = SFXS
  const { volume, sound } = audio
  notificationSFX.volume = parseFloat(volume)
  useEffect(() => {
    if (sound) {
      notificationSFX.load()
      notificationSFX.play()
    }
  }, [sound])

  return (
    <Container unBlur={false} noFadeIn cursor='none'>
      <NotificationContainer
        fadeOut={fadeOut}
        background={colors.secondary}
        textColor={colors.tertiary}
        onClick={() => handleNotification(false)}
      >
        <Icon background={colors.tertiary} />
        <p>{text}</p>
        <CloseSVG onClick={() => handleNotification(false)} />
      </NotificationContainer>
    </Container>
  )
}
